
















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { IUser } from "@/models/users";

@Component
export default class ApiTokens extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  // Methods

  public async createApiToken() {
    if (!this.canCreate) return;
    try {
      this.$store.dispatch(`data/${DataModules.USERS}/openCreateModal`, {
        props: {
          isApiToken: true
        },
        events: {
          success: ({ api_token: token }: IUser) => {
            this.$store.dispatch(`data/${DataModules.API_TOKENS}/show`, token);
            this.$store.dispatch("toast/show", {
              message: this.$t("_sentence.api_token_created")
            });
            this.$bus.$emit("refreshUsersListing");
          }
        }
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  // Computed

  public get canCreate() {
    return this.$userCan("create_user");
  }
}
